import React, { Component } from 'react';
import Pager from 'react-pager';
import ScanResultRow from "./ScanResultRow";
import ScanActions from "./actions/ScanActions";
import Image from "../image/Image";
import ScanFilter from "./ScanFilter";
import ScanForm from "./ScanForm";
import PermissionHelper from "../../../helpers/PermissionHelper";

import {
  MDBSpinner,
  MDBTable,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBLink,
  MDBBtn,
  MDBIcon,
  MDBCardImage
} from 'mdbreact';

import config from '../../../config';


class ScanSearch extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      result: [],
      page: 0,
      limit: 10,
      total: 0,
      visiblePage: 5,
      filters: {
        field_searchterm: null,
        field_customer: this.props.nid
      }
    }


    this.formRef = React.createRef();

    this._onHandlePageChanged = this._onHandlePageChanged.bind(this);
    //console.log(props);
  }

  _onHandlePageChanged(newPage) {
    this.setState({
        page: newPage
    }, () => {
        this.loadScanCollection();
    });
  }

  componentDidMount(){
    this.loadScanCollection();
    //console.log(this);
  }

  loadScanCollection() {


      var component = this;

      /** build filter query **/

      ScanActions._get('All', this.state.filters, this.state.page).then(response => {

        var result = [];
        if(response.data.result) {
          result = Object.entries(response.data.result);
        }

        component.setState({
          result: result,
          loaded: true,
          total: response.data.total
        });

      });
  }

  render() {
    let component = this;
    return (
      <>

      {PermissionHelper._hasPermission('restful post Scan') === true &&
        <>
          <ScanForm searchComponent={this} ref={this.formRef} nid={this.props.nid} />
        </>
      }

      <hr />

        {!this.state.loaded &&
          <div className="text-center"><MDBSpinner key={'scan-loader'} red /></div>
        }

        {component.state.loaded && (
          <>

          {/*<ScanFilter searchComponent={this} /><hr />*/}

            { component.state.result.length > 0 && (


              <MDBTable responsive hover striped>
                <thead>
                  <tr>
                    <th className='th-lg'>
                      Titel
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {true && (
                    component.state.result.map(function(row, j){
                      //console.log(row)
                      return (
                        <ScanResultRow result={row[1]}  key={'scan-result-view-' + row[1].nid + row[1].changed} searchComponent={component} />
                      )
                    })
                  )}
                </tbody>
              </MDBTable>

            )}

            {component.state.result.length == 0 &&
              <div className="empty">Keine Scans vorhanden</div>
            }

            {component.state.loaded && component.state.total > 10 && (
              <>
                <hr />
                <Pager
                      total={Math.ceil(this.state.total / this.state.limit)}
                      current={this.state.page}
                      visiblePages={this.state.visiblePage}
                      titles={{ first: '<|', last: '>|' }}
                      className="pagination-sm pull-right"
                      onPageChanged={this._onHandlePageChanged}
                  />
              </>
            )}
          </>
        )}
      </>
    );
  }
}

export default ScanSearch;
